/**
 * @fileoverview Icon name → lucide-react component map for the "Studio Quiet"
 * redesign. Lets screens reference the design-handoff icon names (`icons.jsx`)
 * while rendering real lucide icons. Import the `Icon` component from
 * `@/components/studio/primitives` and pass one of these names.
 */

import {
  Home, Users, User, BookOpen, Settings, Menu, LayoutGrid, FileText,
  Mic, MicOff, Play, Pause, Square, Send, Share, Pencil, Trash2, Plus, X, Check,
  Archive, ArchiveRestore,
  Search, Download, Copy, Link2, Upload, Headphones, Paperclip,
  ChevronRight, ChevronLeft, ChevronDown, ChevronUp,
  Music, Music2, Calendar, CalendarSync, Clock, Bell, Bookmark, Sparkles, AudioLines, List, Filter,
  Gauge, Guitar, Lock, Shield, ShieldCheck, Eye, EyeOff, Mail, Phone, MapPin, ExternalLink,
  TriangleAlert, Flame, ArrowRight, ArrowDown, ArrowUp, TrendingUp, TrendingDown, Minus, GraduationCap, LogOut, Info, Loader2,
  RotateCcw, Trophy, Medal, Star, Award, Target, Brain, Zap, School, MessageCircle,
  Receipt, CreditCard, DollarSign, ChartColumn, History, SlidersHorizontal,
  Bold, Italic, Underline, ListOrdered, Hourglass, SunMoon,
} from "lucide-react";

/** Handoff icon name → lucide component. */
export const ICONS = {
  // Nav / structure
  home: Home,
  users: Users,
  user: User,
  book: BookOpen,
  settings: Settings,
  sliders: SlidersHorizontal,
  menu: Menu,
  grid: LayoutGrid,
  fileText: FileText,
  receipt: Receipt,
  creditCard: CreditCard,
  dollar: DollarSign,
  // Actions
  mic: Mic,
  micOff: MicOff,
  play: Play,
  pause: Pause,
  stop: Square,
  send: Send,
  share: Share,
  edit: Pencil,
  trash: Trash2,
  archive: Archive,
  archiveRestore: ArchiveRestore,
  plus: Plus,
  x: X,
  check: Check,
  search: Search,
  download: Download,
  copy: Copy,
  link: Link2,
  refresh: RotateCcw,
  loader: Loader2,
  upload: Upload,
  paperclip: Paperclip,
  headphones: Headphones,
  // Chevrons
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  arrow: ArrowRight,
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  trendUp: TrendingUp,
  trendDown: TrendingDown,
  minus: Minus,
  // Content
  music: Music,
  music2: Music2,
  calendar: Calendar,
  calendarSync: CalendarSync,
  clock: Clock,
  hourglass: Hourglass,
  bell: Bell,
  sunMoon: SunMoon,
  bookmark: Bookmark,
  sparkle: Sparkles,
  waveform: AudioLines,
  list: List,
  listOrdered: ListOrdered,
  bold: Bold,
  italic: Italic,
  underline: Underline,
  filter: Filter,
  chart: ChartColumn,
  history: History,
  metronome: Gauge,
  tuner: Guitar,
  lock: Lock,
  shield: Shield,
  shieldCheck: ShieldCheck,
  eye: Eye,
  eyeOff: EyeOff,
  mail: Mail,
  phone: Phone,
  mapPin: MapPin,
  external: ExternalLink,
  alert: TriangleAlert,
  fire: Flame,
  flame: Flame,
  graduation: GraduationCap,
  logout: LogOut,
  info: Info,
  // Portfolio / achievements
  trophy: Trophy,
  medal: Medal,
  star: Star,
  award: Award,
  target: Target,
  brain: Brain,
  zap: Zap,
  school: School,
  message: MessageCircle,
};

export default ICONS;
